import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { Navbar, Footer, Breadcrumbs } from "../../../components/shared";
import { GetUser } from "../../../service/SpatApi";  // Import the API function
import { handleCreateUserFamily } from "../../../service/UserFamilyApi";
import '../../general/General.css';
import { businessNames } from '../../general/DropDownValuesConfig';
import { fetchAddressAreaByPin } from "../../../service/AddressApi";
import useCheckLoggedin from "../../../utils/useCheckLoggedin";
import "react-datepicker/dist/react-datepicker.css";
import { useForm } from "react-hook-form";
import { formatDateToISO, getYearOptions } from "../../../utils/Utilities";
import { showErrorToast } from "../../../utils/Toasts";
import { useSelector } from "react-redux";


const FamilyCreate = () => {
  useCheckLoggedin();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const dateInputRef = useRef(null);
  const [selectedYear, setSelectedYear] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors, isValid, isSubmitting },
    watch,
    setValue
  } = useForm({
    mode: "all",
    shouldUnregister: false,
  });
  const user = useSelector((state) => state.user);  // Accessing the user from Redux store
  const currentEmail = useSelector((state) => state.user.email);  // Assuming you have email in the user slice

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const response = await GetUser(user.email);
        if (response?.status === 200 || response?.status === 201) {
          if (response.data.user.email === currentEmail) {
            setValue("aadhar", response.data.user.aadhar || "");
            setValue("mobile", response.data.user.mobile.slice(-10) || "");
            setValue("firstName", response.data.user.firstName || "");
            setValue("lastName", response.data.user.lastName || "");
            setValue("email", response.data.user.email || "");
          }
        } else if (response?.status === 401 || response?.status === 403) {

          showErrorToast("பயனர் அங்கீகரிக்கப்படவில்லை.");

        } else if (response?.status === 600) {
          showErrorToast("பல முயற்சிகளுக்குப் பிறகும் அங்கீகரிக்க முடியவில்லை...");
        } else {
          showErrorToast("பயனர் தரவைப் பெறுவதில் தோல்வி...");
        }
      } catch (err) {
        console.error("Error fetching user data", err);
      }
    };

    fetchUserDetails();
  }, [setValue, user.email, currentEmail]);

  // Address logic - start
  const [addressOption, setAddressOption] = useState("both");
  const [permanentSelectedAreaId, setPermanentSelectedAreaId] = useState(null);
  const [permanentSelectedSubareaId, setPermanentSelectedSubareaId] = useState(null);
  const [permanentAddressAreas, setPermanentAddressAreas] = useState({});
  const [permanentPincode, setPermanentPincode] = useState('');
  const [tempSelectedAreaId, setTempSelectedAreaId] = useState(null);
  const [tempSelectedSubareaId, setTempSelectedSubareaId] = useState(null);
  const [tempAddressAreas, setTempAddressAreas] = useState({});
  const [tempPincode, setTempPincode] = useState('');
  const [permanentErrorMessage, setPermanentErrorMessage] = useState('');
  const [tempErrorMessage, setTempErrorMessage] = useState('');

  const [loadingPermanentPin, SetLoadingPermanentPin] = useState(false);
  const [loadingTempPin, SetLoadingTempPin] = useState(false);

  // Handle the area selection
  const handleAreaChange = (e) => {
    const selectedId = e.target.value;
    setPermanentSelectedAreaId(selectedId);
    setPermanentSelectedSubareaId(null);
  };
  const handleTempAreaChange = (e) => {
    const selectedId = e.target.value;
    setTempSelectedAreaId(selectedId);
    setTempSelectedSubareaId(null);
  };


  // Handle subarea selection
  const handleSubareaChange = (e) => {
    const selectedId = e.target.value;
    setPermanentSelectedSubareaId(selectedId);
  };
  const handleTempSubareaChange = (e) => {
    const selectedId = e.target.value;
    setTempSelectedSubareaId(selectedId);
  };

  // Load address areas based on the entered pincode
  const loadPermanentAddressAreas = async () => {
    if (!permanentPincode.match(/^\d{6}$/)) {
      setPermanentErrorMessage("6 இலக்க பின்கோடை உள்ளிடவும்");
      return;
    }

    if (permanentPincode !== permanentAddressAreas?.pincode) {
      // Only reset selections if user entered a different pincode
      setPermanentSelectedAreaId(null);
      setPermanentSelectedSubareaId(null);
    }

    SetLoadingPermanentPin(true);
    try {
      const data = await fetchAddressAreaByPin(permanentPincode, 'true');
      if (data?.addressAreaList?.length) {
        setPermanentAddressAreas({ ...data, permanentPincode }); // Save current pincode in state
        setPermanentErrorMessage("");
      } else {
        setPermanentAddressAreas({});
        setPermanentErrorMessage('இந்த பின்கோடுக்கு முகவரிப் பகுதிகள் எதுவும் கிடைக்கவில்லை.');
      }
    } catch (error) {
      setPermanentErrorMessage("முகவரிப் பகுதிகளைப் பெறுவதில் பிழை.");
    } finally {
      SetLoadingPermanentPin(false);
    }
  };
  const loadTempAddressAreas = async () => {
    if (!tempPincode.match(/^\d{6}$/)) {
      setTempErrorMessage("6 இலக்க பின்கோடை உள்ளிடவும்");
      return;
    }

    if (tempPincode !== tempAddressAreas?.pincode) {
      // Only reset selections if user entered a different pincode
      setTempSelectedAreaId(null);
      setTempSelectedSubareaId(null);
    }

    SetLoadingTempPin(true);
    try {
      const data = await fetchAddressAreaByPin(tempPincode, 'true');
      if (data?.addressAreaList?.length) {
        setTempAddressAreas({ ...data, tempPincode }); // Save current pincode in state
        setTempErrorMessage("");
      } else {
        setTempAddressAreas({});
        setTempErrorMessage('இந்த பின்கோடுக்கு முகவரிப் பகுதிகள் எதுவும் கிடைக்கவில்லை.');
      }
    } catch (error) {
      setTempErrorMessage("முகவரிப் பகுதிகளைப் பெறுவதில் பிழை.");
    } finally {
      SetLoadingTempPin(false);
    }
  };
  // Address logic - end
  const handleYearChange = (e) => {
    const year = e.target.value;
    setSelectedYear(year);

    const dateString = `${year}-06-01`;

    // Update both DOM and react-hook-form state
    if (dateInputRef.current) {
      dateInputRef.current.value = dateString;
    }
    setValue("dob", dateString, { shouldValidate: true });
  };
  // Handle form submission
  const handleFormSubmit = async (data) => {
    if (loading) {
      return;  // Prevent form submission if loading is true
    }
    if (!data.firstName || data.firstName.length < 3) {
      alert("பெயர் சரியாக உள்ளிடப்படவில்லை.");
      return;
    }
    setLoading(true);
    // Clean the Aadhaar field specifically (remove spaces)
    if (data.aadhar) {
      data.aadhar = data.aadhar.replace(/\s+/g, ''); // Remove all spaces from Aadhaar
    }
    // Check if permanent address area and subarea are filled
    if (!permanentSelectedAreaId || !permanentSelectedSubareaId) {
      alert("தயவுசெய்து நிரந்தர முகவரியை நிரப்பவும்.");
      setLoading(false);
      return; // Prevent form submission if validation fails
    }
    if (!data.permanentAddressLine1) {
      alert("தயவுசெய்து நிரந்தர முகவரி கதவு எண் நிரப்பவும்.");
      setLoading(false);
      return; // Prevent form submission if validation fails
    }

    const payload = {
      ...data,
      dob: formatDateToISO(data.dob),
      firstName: (data.firstName?.trim() || ""), // Safely trim the firstName or fall back to empty string
      lastName: (data.lastName?.trim() || ""),   // Safely trim lastName or fall back to empty string
      familyName: (data.familyName?.trim() || ""), // Safely trim familyName or fall back to empty string
      tempAddressLine1: (data.tempAddressLine1?.trim() || ""), // Safely trim tempAddressLine1 or fall back to empty string
      tempAddressLine2: (data.tempAddressLine2?.trim() || ""),
      tempAddressLine3: (data.tempAddressLine3?.trim() || ""),
      tempAddressLine1_tamil: (data.tempAddressLine1?.trim() || ""), // Same for Tamil lines
      tempAddressLine2_tamil: (data.tempAddressLine2?.trim() || ""),
      tempAddressLine3_tamil: (data.tempAddressLine3?.trim() || ""),
      tempAddressAreaId: tempSelectedAreaId || "", // Default to empty string if areaId is undefined
      tempSubareaId: tempSelectedSubareaId || "", // Default to empty string if subareaId is undefined
      permanentAddressLine1: (data.permanentAddressLine1?.trim() || ""), // Safely trim permanent address lines
      permanentAddressLine2: (data.permanentAddressLine2?.trim() || ""),
      permanentAddressLine3: (data.permanentAddressLine3?.trim() || ""),
      permanentAddressLine1_tamil: (data.permanentAddressLine1?.trim() || ""),
      permanentAddressLine2_tamil: (data.permanentAddressLine2?.trim() || ""),
      permanentAddressLine3_tamil: (data.permanentAddressLine3?.trim() || ""),
      permanentAddressAreaId: permanentSelectedAreaId || "", // Default to empty string if areaId is undefined
      permanentSubareaId: permanentSelectedSubareaId || "", // Default to empty string if subareaId is undefined
    };

    try {
      const success = await handleCreateUserFamily(payload);
      if (success) {
        navigate(`/user/family/member-view/${data.aadhar}`);
      }
    } catch (error) {
      console.error("Error creating family:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <Helmet>
        <title>ஸ்ரீ பொன்னாச்சி அம்மன் திருக்கோவில்கள் | குடும்ப வடிவம்</title>
        <link rel="canonical" href="/family/create" />
      </Helmet>

      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <Breadcrumbs /><br />
            <form onSubmit={(e) => { handleSubmit(handleFormSubmit)(e); }} className="auth_form" autoComplete="off">
              <h1>குடும்ப வடிவம்</h1>
              {/* Address Option Selection */}
              <div className="auth_element">
                <label className="auth_label">முகவரி வகையைத் தேர்வுசெய்யவும்</label>
                <br />
                <div className="auth_radio">
                  <label className="auth_radio-label">
                    <input
                      type="radio"
                      name="addressOption"
                      value="both"
                      checked={addressOption === "both"}
                      onChange={() => setAddressOption("both")}
                    />
                    தற்காலிக மற்றும் நிரந்தர முகவரிகள்
                  </label>
                  <br />
                  <label className="auth_radio-label">
                    <input
                      type="radio"
                      name="addressOption"
                      value="permanent"
                      checked={addressOption === "permanent"}
                      onChange={() => setAddressOption("permanent")}
                    />
                    நிரந்தர முகவரி மட்டும்
                  </label>
                </div>
              </div>


              <>
                {/* Address Line Inputs */}
                <label className="auth_label">நிரந்தர முகவரி</label>
                {/* Pincode Input */}
                <div className="auth_element">
                  <label className="auth_label">பின்கோடு</label>
                  <input
                    type="text"
                    value={permanentPincode}
                    onChange={(e) => setPermanentPincode(e.target.value)}
                    className="auth_input"
                    placeholder="பின்கோடை உள்ளிடவும்"
                    autoComplete="off"
                    inputMode="numeric"
                    maxLength="6"
                  />
                  <button type="button" onClick={loadPermanentAddressAreas} disabled={loadingPermanentPin}>
                    {loadingPermanentPin ? "ஏற்றுகிறது..." : "முகவரிப் பகுதிகளை ஏற்று"}
                  </button>
                  {permanentErrorMessage && <div className="auth_error">{permanentErrorMessage}</div>}
                  <br />
                </div>

                {/* Address Area Selection */}
                {permanentAddressAreas?.addressAreaList?.length > 0 && (
                  <div className="auth_element" style={{ marginBottom: '20px' }}>
                    <select
                      value={permanentSelectedAreaId || ""}
                      onChange={handleAreaChange}
                      className="auth_select"
                    >
                      <option value="" disabled>பகுதியைத் தேர்ந்தெடுக்கவும்</option>
                      {permanentAddressAreas.addressAreaList.map((area) => (
                        <option key={area.id} value={area.id}>
                          {`${area.name_tamil || area.name}, ${area.block_tamil || area.block}, ${area.district_tamil || area.district}`}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {/* Subarea Selection */}
                {permanentSelectedAreaId && (
                  <div className="auth_element" style={{ marginTop: '20px' }}>
                    <label>ஊரைத் தேர்ந்தெடுக்கவும்:</label>
                    {permanentAddressAreas?.addressAreaList.find((area) => area.id === permanentSelectedAreaId)?.subAreas?.length > 0 ? (
                      <select
                        value={permanentSelectedSubareaId || ""}
                        onChange={handleSubareaChange}
                        className="auth_select"
                      >
                        <option value="" disabled>ஒரு ஊரைத் தேர்ந்தெடுக்கவும்</option>
                        {permanentAddressAreas.addressAreaList.find((area) => area.id === permanentSelectedAreaId).subAreas.map((subarea) => (
                          <option key={subarea.id} value={subarea.id}>
                            {(subarea.name_tamil || subarea.name)
                              ? (subarea.name_tamil || subarea.name).split('|').reverse().map((s) => s.trim()).join(', ')
                              : 'ஊர் கிடைக்கவில்லை'}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <p>இந்தப் பகுதிக்கு எந்த இடமும் கிடைக்கவில்லை...</p>
                    )}
                  </div>
                )}
                {permanentSelectedSubareaId && (
                  <>
                    <div className="auth_element">
                      <label className="auth_label">நிரந்தர முகவரி கதவு எண்</label>
                      <input
                        type="text"
                        id="permanentAddressLine1"
                        {...register("permanentAddressLine1", {
                          required: "நிரந்தர முகவரி கதவு எண் தேவை",
                        })}
                        className="auth_input"

                      />
                      {errors.permanentAddressLine1 && <div className="auth_error">❗ {errors.permanentAddressLine1.message}</div>}
                    </div>
                    <div className="auth_element">
                      <label className="auth_label">நிரந்தர முகவரி தெரு(தமிழில் கொடுங்கள்-Optional)</label>
                      <input
                        type="text"
                        id="permanentAddressLine2"
                        // value={addressData.permanent.addressLine2}
                        {...register("permanentAddressLine2")}
                        className="auth_input"

                      />
                      {errors.permanentAddressLine2 && <div className="auth_error">❗ {errors.permanentAddressLine2.message}</div>}
                    </div>
                    <div className="auth_element">
                      <label className="auth_label">நிரந்தர முகவரி கூடுதல் விவரம்(தமிழில் கொடுங்கள்-Optional)</label>
                      <input
                        type="text"
                        id="permanentAddressLine3"
                        // value={addressData.permanent.addressLine3}
                        {...register("permanentAddressLine3")}
                        className="auth_input"
                      />
                      {errors.permanentAddressLine3 && <div className="auth_error">❗ {errors.permanentAddressLine3.message}</div>}
                    </div>
                  </>
                )}
              </>
              {/* Temporary Address Selection (Only show if "Both" is selected) */}
              {addressOption === "both" && (
                <>
                  {/* Address Line Inputs */}
                  <hr />
                  <label className="auth_label">தற்காலிக முகவரி</label>
                  {/* Pincode Input */}
                  <div className="auth_element">
                    <label className="auth_label">பின்கோடு</label>
                    <input
                      type="text"
                      value={tempPincode}
                      onChange={(e) => setTempPincode(e.target.value)}
                      className="auth_input"
                      placeholder="பின்கோடை உள்ளிடவும்"
                      autoComplete="off"
                      inputMode="numeric"
                      maxLength="6"
                    />
                    <button type="button" onClick={loadTempAddressAreas} disabled={loadingTempPin}>
                      {loadingTempPin ? "ஏற்றுகிறது..." : "முகவரிப் பகுதிகளை ஏற்று"}
                    </button>
                    {tempErrorMessage && <div className="auth_error">{tempErrorMessage}</div>}
                    <br />
                  </div>

                  {/* Address Area Selection */}
                  {tempAddressAreas?.addressAreaList?.length > 0 && (
                    <div className="auth_element" style={{ marginBottom: '20px' }}>
                      <select
                        value={tempSelectedAreaId || ""}
                        onChange={handleTempAreaChange}
                        className="auth_select"
                      >
                        <option value="" disabled>பகுதியைத் தேர்ந்தெடுக்கவும்</option>
                        {tempAddressAreas.addressAreaList.map((area) => (
                          <option key={area.id} value={area.id}>
                            {`${area.name_tamil || area.name}, ${area.block_tamil || area.block}, ${area.district_tamil || area.district}`}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {/* Subarea Selection */}
                  {tempSelectedAreaId && (
                    <div className="auth_element" style={{ marginTop: '20px' }}>
                      <label>ஊரைத் தேர்ந்தெடுக்கவும்:</label>
                      {tempAddressAreas?.addressAreaList.find((area) => area.id === tempSelectedAreaId)?.subAreas?.length > 0 ? (
                        <select
                          value={tempSelectedSubareaId || ""}
                          onChange={handleTempSubareaChange}
                          className="auth_select"
                        >
                          <option value="" disabled>ஒரு ஊரைத் தேர்ந்தெடுக்கவும்</option>
                          {tempAddressAreas.addressAreaList.find((area) => area.id === tempSelectedAreaId).subAreas.map((subarea) => (
                            <option key={subarea.id} value={subarea.id}>
                              {(subarea.name_tamil || subarea.name)
                                ? (subarea.name_tamil || subarea.name).split('|').reverse().map((s) => s.trim()).join(', ')
                                : 'ஊர் கிடைக்கவில்லை'}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <p>இந்தப் பகுதிக்கு எந்த இடமும் கிடைக்கவில்லை...</p>
                      )}
                    </div>
                  )}
                  {tempSelectedSubareaId && (
                    <>
                      <div className="auth_element">
                        <label className="auth_label">தற்காலிக கதவு எண்</label>
                        <input
                          type="text"
                          id="tempAddressLine1"
                          //value={addressData.temp.addressLine1}
                          {...register("tempAddressLine1", {
                            required: "தற்காலிக கதவு எண் தேவை",
                          })}
                          className="auth_input"
                        />
                        {errors.tempAddressLine1 && <div className="auth_error">❗ {errors.tempAddressLine1.message}</div>}
                      </div>

                      <div className="auth_element">
                        <label className="auth_label">தற்காலிக முகவரி தெரு(தமிழில் கொடுங்கள்-Optional)</label>
                        <input
                          type="text"
                          id="tempAddressLine2"
                          // value={addressData.temp.addressLine2}
                          {...register("tempAddressLine2")}
                          className="auth_input"

                        />
                        {errors.tempAddressLine2 && <div className="auth_error">❗ {errors.tempAddressLine2.message}</div>}
                      </div>

                      <div className="auth_element">
                        <label className="auth_label">தற்காலிக முகவரி கூடுதல் விவரம்(தமிழில் கொடுங்கள்-Optional)</label>
                        <input
                          type="text"
                          id="tempAddressLine3"
                          //value={addressData.temp.addressLine3}
                          {...register("tempAddressLine3")}
                          className="auth_input"
                        />
                        {errors.tempAddressLine3 && <div className="auth_error">❗ {errors.tempAddressLine3.message}</div>}
                      </div>
                    </>
                  )}
                </>
              )}

              <hr></hr>
              {/* Adddress logic end */}

              <div className="auth_element">
                <label className="auth_label">கூட்டம்</label>
                <select
                  id="kootamName"
                  {...register("kootamName", { required: "கூட்டம் தேர்வு செய்ய வேண்டும்" })}
                  className="auth_select"
                >
                  <option value="">-- கூட்டத்தை தேர்ந்தெடுக்கவும் --</option>
                  <option value="செம்பூத்தான்">செம்பூத்தான்</option>
                  <option value="மணியன்">மணியன்</option>
                  <option value="முத்தன்">முத்தன்</option>
                  <option value="பிற">பிற (கூட்டம்)</option>
                </select>
                {errors.kootamName && <div className="auth_error">❗ {errors.kootamName.message}</div>}

                {/* Custom Group as Free Text Input */}
                {watch("kootamName") === "பிற" && (
                  <div className="auth_element">
                    <label className="auth_label">பிற (கூட்டம் - தமிழில் கொடுங்கள்)</label>
                    <input
                      type="text"
                      id="customGroup"
                      placeholder="உங்கள் கூட்டத்தை உள்ளிடவும்"
                      {...register("customGroup", {
                        required: "பிற (கூட்டம்) தேவை",
                      })}
                      className="auth_input"
                    />
                    {errors.customGroup && <div className="auth_error">❗ {errors.customGroup.message}</div>}
                  </div>
                )}

              </div>
              <div className="auth_element">
                <label className="auth_label">குடும்ப தலைவர் பெயர் (தமிழில் கொடுங்கள்)</label>
                <input
                  type="text"
                  id="firstName"
                  {...register("firstName", {
                    required: "குடும்ப தலைவர் பெயர் தேவை",
                    pattern: { value: /^[A-Za-z\u0B80-\u0BFF\s.]*$/, message: "எழுத்துக்கள், இடைவெளிகள் மற்றும் '.' மட்டும் அனுமதிக்கப்படும்" },
                    minLength: { value: 2, message: "குறைந்தது 2 எழுத்துகள் வேண்டும்" },
                  })}
                  className="auth_input"
                  placeholder="பொன்னாச்சி"
                />
                {errors.firstName && <div className="auth_error">❗ {errors.firstName.message}</div>}
              </div>

              <div className="auth_element">
                <label className="auth_label">தந்தை/கணவர் பெயர் (தமிழில் கொடுங்கள்)</label>
                <input
                  type="text"
                  id="lastName"
                  {...register("lastName", {
                    required: "தந்தை/கணவர் பெயர் தேவை",
                    pattern: { value: /^[A-Za-z\u0B80-\u0BFF\s.]*$/, message: "எழுத்துக்கள், இடைவெளிகள் மற்றும் '.' மட்டும் அனுமதிக்கப்படும்" },
                    minLength: { value: 2, message: "குறைந்தது 2 எழுத்துகள் வேண்டும்" },
                  })}
                  className="auth_input"
                  placeholder="அம்மன்"
                />
                {errors.lastName && <div className="auth_error">❗ {errors.lastName.message}</div>}
              </div>

              <div className="auth_element">
                <label className="auth_label">குடும்ப பட்ட பெயர் (தமிழில் கொடுங்கள் - Optional)</label>
                <input
                  type="text"
                  id="familyName"
                  {...register("familyName", {
                    pattern: { value: /^[A-Za-z\u0B80-\u0BFF\s.]*$/, message: "எழுத்துக்கள், இடைவெளிகள் மற்றும் '.' மட்டும் அனுமதிக்கப்படும்" },
                  })}
                  className="auth_input"
                  placeholder="குடும்பம்"
                />
                {errors.familyName && <div className="auth_error">❗ {errors.familyName.message}</div>}
              </div>

              {/* Date of Birth */}
              <div className="auth_element">
                <label className="auth_label">பிறந்த தேதி</label>

                <div style={{ display: "flex", gap: "10px" }}>
                  {/* Year dropdown */}
                  <select
                    onChange={handleYearChange}
                    value={selectedYear}
                    className="auth_input"
                  >
                    <option value="">ஆண்டு தேர்வு செய்யவும்</option>
                    {getYearOptions(1940).map((year) => (
                      <option key={year} value={year}>{year}</option>
                    ))}
                  </select>

                  {/* Actual date input */}
                  <input
                    type="date"
                    id="dob"
                    ref={dateInputRef}
                    {...register("dob", {
                      required: "பிறந்த தேதி தேவை",
                    })}
                    className="auth_input"
                  />
                </div>

                {errors.dob && (
                  <div className="auth_error">❗ {errors.dob.message}</div>
                )}
              </div>


              {/* Aadhar Number Field */}
              <div className="auth_element">
                <label className="auth_label">ஆதார் எண்(உங்கள் பயனர் பதிவின்படி ஆதார்)</label>
                <input
                  type="text"
                  id="aadhar"
                  {...register("aadhar", {
                    required: "ஆதார் எண் தேவை",
                    pattern: {
                      value: /^(?!00)\d{12}(?<!00)$/,
                      message: "12-இலக்க எண்ணாக இருக்க வேண்டும்,இடைவெளிகளைக் கொண்டிருக்கலாம்",
                    },
                  })}
                  className="auth_input"
                  placeholder="1234 5678 9012"
                  autoComplete="off"
                  inputMode="numeric"
                  maxLength="12"
                  readOnly
                />
                {errors.aadhar && <div className="auth_error">❗ {errors.aadhar.message}</div>}
              </div>

              {/* Mobile Number Field */}
              <div className="auth_element">
                <label className="auth_label">கைபேசி எண் (OTP சரிபார்க்கப்பட்ட மொபைல் எண்)</label>
                <input
                  type="tel"
                  id="mobile"
                  {...register("mobile", {
                    required: "கைபேசி எண் தேவை",
                    pattern: {
                      value: /^\d{10}$/,
                      message: "சரியான கைபேசி எண்ணை உள்ளிடவும்",
                    },
                  })}
                  className="auth_input"
                  placeholder="1234567890"
                  autoComplete="off"
                  inputMode="numeric"
                  maxLength="10"
                  readOnly
                />
                {errors.mobile && <div className="auth_error"> {errors.mobile.message}</div>}
              </div>

              {/* Mobile Number Field */}
              <div className="auth_element">
                <label className="auth_label">கைபேசி எண் 2 (Optional)</label>
                <input
                  type="tel"
                  id="mobile2"
                  {...register("mobile2", {

                    pattern: {
                      value: /^\+91[-]?\d{3}[-]?\d{3}[-]?\d{4}$|^(?:\+?\d{1,3})?[-.\s]?(\(?\d{2,3}\)?)?[-.\s]?\d{3}[-.\s]?\d{4}$/,
                      message: "சரியான கைபேசி எண்ணை உள்ளிடவும்",
                    },
                  })}
                  className="auth_input"
                  placeholder="+91-1234567890"
                  inputMode="numeric"
                />
                {errors.mobile2 && <div className="auth_error"> {errors.mobile2.message}</div>}
              </div>

              <div className="auth_element">
                <label className="auth_label">மின்னஞ்சல் (சரிபார்க்கப்பட்ட மின்னஞ்சலைக் கொடுங்கள்)</label>
                <input
                  type="email"
                  id="email"
                  {...register("email", {
                    required: "மின்னஞ்சல் தேவை",
                    pattern: {
                      value: /^[a-zA-Z0-9._%+-]+(?:[a-zA-Z0-9-]*[a-zA-Z0-9]+)*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, // Improved regex to match most valid email formats
                      message: "மின்னஞ்சல் செல்லுபடியாகாது",
                    },
                  })}
                  className="auth_input"
                  placeholder="ponnachiamman@gmail.com"
                  readOnly
                />
                {errors.email && <div className="auth_error">❗ {errors.email.message}</div>}
              </div>

              <div className="auth_element">
                <label className="auth_label">வணிக பெயர் (Optional)</label>
                <select
                  id="businessName"
                  {...register("businessName")}
                  className="auth_select"
                >
                  <option value="">-- தேர்ந்தெடுக்கவும் --</option>
                  {businessNames.map((business) => (
                    <option key={business.value} value={business.value}>
                      {business.label}
                    </option>
                  ))}
                </select>
                {errors.businessName && <div className="auth_error">❗ {errors.businessName.message}</div>}
              </div>

              <button type="submit" disabled={!isValid || isSubmitting}
                className={`auth_submit ${!isValid || isSubmitting ? "disabled_btn" : ""}`}
              >
                {loading ? 'சமர்ப்பிக்கிறது...' : 'சமர்ப்பிக்கவும்'}
              </button>
            </form>
            <br />
            <button onClick={() => navigate("/user/profile")}>என் கணக்கிற்குச் செல்</button>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default FamilyCreate;